import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
    standalone: false,
    selector: 'app-add-audit-stage-record-dialog',
  templateUrl: './add-audit-stage-dialog.component.html',
  styleUrls: ['./add-audit-stage-dialog.component.scss']
})
export class AddAuditStageDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  inputForm: any;
  stageName = '';

  constructor(private formBuilder: FormBuilder) {
    this.inputForm = this.formBuilder.group({
      stageName: ['', [Validators.required, Validators.pattern('[^\\\\/:*?\\"<>|]*')]]
    });
  }

  ngOnInit(): void {
    if (this.data.input['stageName']) {
      this.stageName = this.data.input['stageName'];
    }
    this.inputForm.valueChanges.subscribe(() => {
      this.data.isDisabledOkButton = this.inputForm.invalid;
    });
  }

  onOkClicked(): boolean {
    const stageNameControl = this.inputForm.controls['stageName'];

    stageNameControl.markAsTouched();

    if (stageNameControl.hasError('required')) {
      return false;
    }

    this.data.input['StageName'] = stageNameControl.value;

    return true;
  }

}
